import { reduceSeriesToValue, reduceSeriesToValuePreviousPeriod } from "../lib"

export const engagementsMapper = (metrics, days) => {
  return {
    dailyMetrics: metrics,
    serviceEngagements: reduceSeriesToValue(
      metrics,
      days,
      "service_engagement_daily"
    ),
    serviceEngagementsLastPeriod: reduceSeriesToValuePreviousPeriod(
      metrics,
      days,
      "service_engagement_daily"
    ),
    userEngagementRate: metrics
      .map(d => d["service_engagement_daily"] / d["new_users_all_time"])
      .slice(-days)
      .reduce((a, b) => a + b, 0),
  }
}
